import React, {useEffect, useState} from 'react';
import {Form, message, Spin} from 'antd';
import {gql, useLazyQuery, useMutation} from '@apollo/client';
import {CREATE_PROFILE} from './../graphql/mutations/profile';
import {PROFILES_CONNECTION} from '../graphql/query/profiles';
import {useDispatch, useSelector} from 'react-redux';
import {currentUserWithAllData} from '../utils/helpers/currentUser';
import {setUserProfile} from '../redux/actions/profile';
import lodash from 'lodash';
import {setTokens} from '../redux/actions/auth';
import {useHistory} from 'react-router-dom';
import {setStrapiResData} from '../redux/actions/strapiRes';
import {userTokenData} from '../utils/helpers/google';

const UserDetails = () => {
  const history = useHistory();
  const {authToken} = useSelector((state) => state.Auth);
  const strapiRes = useSelector((state) => state.strapiRes);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userName, setUserName] = useState('');
  const [userId, setUser] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [count, setCount] = useState(0);
  const [accessToken, setAccessToken] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const storageUserName = localStorage.getItem('username');

  const {userProfile} = useSelector((state) => state.Profile);

  const getAccessToken = async () => {
    const accessTokenData = await localStorage.getItem('accessToken');
    setAccessToken(accessTokenData);
    const accountTypeData = await localStorage.getItem('accountType');
    setAccountType(accountTypeData);
  };

  useEffect(() => {
    getAccessToken();
  }, [accountType, accessToken]);

  const dispatch = useDispatch();

  const userData = async () => {
    const userId = localStorage.getItem('userId');
    setUser(userId);
    const userEmail = localStorage.getItem('email');
    setEmail(userEmail);
  };

  useEffect(() => {
    userData();
  }, [userId, email]);

  useEffect(() => {
    if (accessToken && accountType && accountType !== 'custom') {
      if (!userProfile) {
        userTokenData(accessToken)
          .then((res) =>
            dispatch(
              setUserProfile({
                userId: res.id,
                email: res.email,
              }),
            ),
          )
          .catch((err) => {
            localStorage.clear();
            message.error('some error occured.');
            history.push('/');
          });
      } else {
        setData();
      }
    } else if (accessToken && accountType === 'custom') {
      if (!userProfile) {
        currentUserWithAllData(accessToken)
          .then((data) => {
            dispatch(
              setUserProfile({
                userId: data.userId,
                email: data.email,
              }),
            );
            if (storageUserName) {
              setUserName(storageUserName);
              debounce(storageUserName);
            }
          })
          .catch((err) => {
            localStorage.clear();
            message.error('some error occured.');
            history.push('/');
          });
      } else {
        setData();
      }
    } else {
      setData();
    }
  }, []);

  const setData = () => {
    setFirstName(userProfile?.firstName || '');
    setLastName(userProfile?.lastName || '');
    setUserName(userProfile?.userName || '');
    debounce(userProfile?.userName || storageUserName);
    userProfile?.checked && setChecked(true);
  };

  const handleUserNameCheck = (userName) => {
    if (!userName) {
      return setChecked(false);
    }
  };

  const debounce = lodash.debounce((event) => handleUserNameCheck(event), 1000);

  const [createProfile] = useMutation(gql(CREATE_PROFILE));
  const submitHandler = async () => {
    setLoading(true);
    if (!checked) {
      createProfile({
        variables: {
          firstName,
          lastName,
          userName: userName.toLowerCase(),
          userId: userId,
          email: email,
        },
      })
        .then(async (res) => {
          setLoading(false);
          dispatch({
            type: 'SET_STRAPI_RES_DATA',
            payload: res?.data?.createProfile?.profile,
          });
          history.push(`/${strapiRes?.userName}`);
          await localStorage.removeItem('accessToken');
          await localStorage.removeItem('accountType');
          await localStorage.setItem(
            'profileId',
            res.data?.createProfile?.profile?.id.toString(),
          );
          dispatch(
            setTokens({
              accessToken: null,
              authToken,
              accountType: null,
            }),
          );
        })
        .catch((err) => {
          setLoading(false);
          message.error(err.message);
        });
    }
  };

  const [profilesConnection] = useLazyQuery(gql(PROFILES_CONNECTION), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({profilesConnection}) => {
      setCount(profilesConnection.aggregate.count);
    },
  });

  useEffect(() => {
    setUserName(`${firstName.charAt(0)}${lastName}`);
  }, [firstName, lastName]);

  useEffect(() => {
    if (count > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [count]);

  const userNameCheck = () => {
    profilesConnection({
      variables: {
        userName: userName.toLowerCase(),
      },
    });
  };

  const handleUserName = (value) => {
    profilesConnection({
      variables: {
        userName: value,
      },
    });
    setUserName(value);
    debounce(value);
  };

  return (
    <Spin
      spinning={loading}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}>
      <div className="signup-container">
        <h1 className="headingz">ZOMBIE</h1>
        <div className="card-body">
          <div className="row d-flex sign">
            <h1 className="heading">Get started</h1>
          </div>
          <div className="d-flex sign mb-4 pl-0">
            <h6 className="heading-account">Set up your account</h6>
          </div>
          <div className="content-wrapper mt-4">
            <Form className="form" onFinish={() => submitHandler()}>
              <div className="input-field">
                <label>First name</label>
                <input
                  type="text"
                  placeholder="Jin"
                  name="firstName"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                />
              </div>
              <div className="input-field">
                <label>Last name</label>
                <input
                  type="text"
                  placeholder="Lee"
                  name="lastName"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                  onBlur={() => userNameCheck()}
                />
              </div>
              <div className="input-field">
                <label>Username</label>
                {checked ? (
                  <p className="error">Sorry, username is taken.</p>
                ) : null}
                <input
                  type="text"
                  placeholder="@jlee"
                  name="userName"
                  maxLength={15}
                  value={userName.toLowerCase()}
                  onChange={(e) => {
                    handleUserName(e.target.value);
                  }}
                />
              </div>
              {checked ? (
                <div className="signUp pb-4 pt-3">
                  <button disabled={true} className="google">
                    Done
                  </button>
                </div>
              ) : (
                <div className="signUp pb-4 pt-3">
                  <button className="google">Done</button>
                </div>
              )}
            </Form>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default UserDetails;
